export default function RenovationHero() {
  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stunning%20modern%20home%20renovation%20interior%20design%20Switzerland%20Neuenegg%20Fribourg%20bright%20spacious%20living%20room%20white%20walls%20wooden%20floor%20elegant%20minimalist%20style%20professional%20photography%20high%20quality%20architectural&width=1920&height=700&seq=renovation-hero-casa-01&orientation=landscape"
          alt="Travaux de rénovation CasaReNovaPlus"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/40 text-emerald-300 text-xs font-semibold px-4 py-2 rounded-full mb-6 uppercase tracking-widest">
            <i className="ri-home-gear-line"></i>
            Rénovation & Transformation
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-5">
            Tous types de<br />
            <span className="text-emerald-400">travaux de rénovation</span>
          </h1>
          <p className="text-gray-300 text-lg leading-relaxed mb-8">
            CasaReNovaPlus réalise tous vos projets de rénovation à Neuenegg et en Suisse romande. Cuisine, salle de bain, peinture, parquet, menuiserie — des artisans qualifiés pour transformer votre espace.
          </p>
          <div className="flex flex-wrap gap-4">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              Devis gratuit
            </a>
            <a
              href="#references"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold px-8 py-4 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-image-line"></i>
              Voir nos références
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { value: '19+', label: "Ans d'expérience" },
              { value: '200+', label: 'Projets réalisés' },
              { value: '100%', label: 'Satisfaction client' },
            ].map((stat) => (
              <div key={stat.label} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center border border-white/20">
                <p className="text-2xl font-black text-emerald-400">{stat.value}</p>
                <p className="text-xs text-gray-300 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
